module.exports = __webpack_public_path__ + "img/Users-logo.631904d1.svg";